import { ref } from "vue";

const getLocation = (id) => {
    const location = ref([null])
    const error = ref([null])

    const load = async() => {
        try {
            let locationdata = await fetch( 'https://rickandmortyapi.com/api/location/'+id )
            if( !locationdata.ok ) {
                throw Error('Computer says no!')
            }
            location.value = await locationdata.json()
        } catch (err) {
            error.value = err.message
            console.log( err.value )
        }
    }
    return { location, error, load }
}
export default getLocation